import { EventEmitter, Component, ViewContainerRef, ComponentFactoryResolver, Input, Directive, ElementRef, HostListener, TemplateRef, Inject, PLATFORM_ID, NgModule, Injectable } from '@angular/core';
import { ViewportScroller, isPlatformServer } from '@angular/common';
import { Router } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';
class DynamicComponentComponent {
    /**
     * @param {?} _vcRef
     * @param {?} _cfResolver
     */
    constructor(_vcRef, _cfResolver) {
        this._vcRef = _vcRef;
        this._cfResolver = _cfResolver;
        this.inputs = {};
        this.subscriptions = {};
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes['component'].currentValue) {
            this._vcRef.clear();
            /** @type {?} */
            const cf = this._cfResolver.resolveComponentFactory(this.component);
            this._component = this._vcRef.createComponent(cf);
        }
        if (changes['inputs'].currentValue ||
            changes['component'].currentValue) {
            Object.keys(this.inputs).forEach((/**
             * @param {?} key
             * @return {?}
             */
            key => {
                this._component.instance[key] = this.inputs[key];
            }));
        }
        if ((changes['outputs'] &&
            changes['outputs'].currentValue &&
            this._component) ||
            (changes['component'] &&
                changes['component'].currentValue &&
                this.outputs)) {
            if (this.outputs) {
                /** @type {?} */
                const newOutputs = Object.keys(this.outputs).filter((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => !this.subscriptions[key]));
                /** @type {?} */
                const removedOutputs = Object.keys(this.subscriptions).filter((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => !(/** @type {?} */ (this.outputs))[key]));
                newOutputs.forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                (key) => {
                    if (this._component.instance.hasOwnProperty(key) &&
                        this._component.instance[key] instanceof EventEmitter) {
                        this.subscriptions[key] = this._component.instance[key].subscribe((/**
                         * @param {?} data
                         * @return {?}
                         */
                        (data) => {
                            if (this.outputs && this.outputs.key) {
                                ((/** @type {?} */ (this.outputs[key])))(data);
                            }
                        }));
                    }
                }));
                removedOutputs.forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => {
                    this.subscriptions[key].unsubscribe();
                    delete this.subscriptions[key];
                }));
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        Object.keys(this.subscriptions).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => this.subscriptions[key].unsubscribe()));
    }
}
/** @nocollapse */
DynamicComponentComponent.ɵfac = function DynamicComponentComponent_Factory(t) { return new (t || DynamicComponentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
/** @nocollapse */
DynamicComponentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicComponentComponent, selectors: [["dynamic-component"]], inputs: { inputs: "inputs", component: "component", outputs: "outputs" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function DynamicComponentComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
DynamicComponentComponent.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver }
];
DynamicComponentComponent.propDecorators = {
    component: [{ type: Input }],
    inputs: [{ type: Input }],
    outputs: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicComponentComponent, [{
        type: Component,
        args: [{
                selector: 'dynamic-component',
                preserveWhitespaces: false,
                template: ' '
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { inputs: [{
            type: Input
        }], component: [{
            type: Input
        }], outputs: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InterceptLinksDirective {
    /**
     * @param {?} elementRef
     * @param {?} router
     * @param {?} viewportScroller
     */
    constructor(elementRef, router, viewportScroller) {
        this.elementRef = elementRef;
        this.router = router;
        this.viewportScroller = viewportScroller;
    }
    /**
     * Support scroll in dialog/overlay
     * Pass in the dialog element id, if used to scroll to and anchor in dialog/overlay
     * @param {?} id
     * @return {?}
     */
    set dialogId(id) {
        this._dialogId = id;
    }
    /**
     * Set the paths either by a string or a regex that should not be considered when parsing clicks
     * @param {?} paths
     * @return {?}
     */
    set exclude(paths) {
        if (paths instanceof RegExp) {
            this._excludedPathRegex = paths;
        }
        else if (typeof paths === 'string') {
            this._excludedPathRegex = new RegExp(paths);
        }
        else {
            this._excludedPathRegex = new RegExp(paths.join('|'));
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        // Find the linkElement that was clicked
        /** @type {?} */
        let linkEle = (/** @type {?} */ ($event.target));
        // look up recursively until you find a linkElement
        // break when reaching container
        if (linkEle.tagName !== 'A') {
            while (linkEle.tagName !== 'A') {
                if (linkEle === this.elementRef.nativeElement) {
                    return true;
                }
                linkEle = (/** @type {?} */ (linkEle.parentElement));
            }
        }
        // Eject if we lost the link element
        if (!linkEle) {
            return true;
        }
        // Eject if link has download attribute
        if (!!linkEle.download) {
            return true;
        }
        // Eject if link has a target thats not empty or top
        if (['', 'top', undefined].indexOf(linkEle.target) === -1) {
            return true;
        }
        this.navigate(linkEle.href);
        return false;
    }
    /**
     * Navigate to any internal url that is not excluded by the [exclude] input
     * @param {?} path
     * @return {?}
     */
    navigate(path) {
        /** @type {?} */
        const url = new URL(path);
        // Eject if link points to another domain
        if (url.host !== location.host) {
            return;
        }
        // Check for excluded paths
        if (this._excludedPathRegex &&
            this._excludedPathRegex.test(url.pathname)) {
            return;
        }
        if (url.pathname === location.pathname && url.hash) {
            return;
        }
        /** @type {?} */
        const strippedUrlHash = url.hash
            ? url.hash.replace('#', '')
            : undefined;
        /** @type {?} */
        const extras = {
            fragment: strippedUrlHash,
            queryParams: this._parseQueryParams(url.search),
        };
        /**
         * If you are still here, the router will take over and do the navigation
         *
         * When anchor linking to an id the pathname will always be '/' because of "<base href="/">" in index.html.
         */
        if (url.hash && url.pathname === '/' && strippedUrlHash) {
            // If interceptLink is used in an overlay
            if (this._dialogId) {
                this._scrollToAnchorInDialog(strippedUrlHash);
                return;
            }
            // If it's the same hash, the scroll effect will not work, so use viewportScroller.scrollToAnchor instead
            if (url.hash === location.hash) {
                this.viewportScroller.scrollToAnchor(strippedUrlHash);
            }
            else {
                this.router.navigate([], extras);
            }
        }
        else {
            this.router.navigate([url.pathname], extras);
        }
    }
    /**
     * @private
     * @param {?} anchorId
     * @return {?}
     */
    _scrollToAnchorInDialog(anchorId) {
        if (!this._dialogId) {
            return;
        }
        /** @type {?} */
        const dialogElement = document.getElementById(this._dialogId);
        if (dialogElement) {
            /** @type {?} */
            let idElement;
            /** @type {?} */
            const goToId = document.getElementById(anchorId);
            /** @type {?} */
            const goToName = document.getElementsByName(anchorId);
            if (goToId) {
                idElement = goToId;
            }
            else if (goToName) {
                idElement = goToName[0];
            }
            if (idElement) {
                idElement.scrollIntoView(true);
            }
        }
    }
    /**
     * @private
     * @param {?} searchString
     * @return {?}
     */
    _parseQueryParams(searchString) {
        return searchString
            .substring(1)
            .split('&')
            .reduce((/**
         * @param {?} params
         * @param {?} pair
         * @return {?}
         */
        (params, pair) => {
            /** @type {?} */
            const kv = pair.split('=');
            params[kv[0]] = kv[1];
            return params;
        }), {});
    }
}
/** @nocollapse */
InterceptLinksDirective.ɵfac = function InterceptLinksDirective_Factory(t) { return new (t || InterceptLinksDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ViewportScroller)); };
/** @nocollapse */
InterceptLinksDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: InterceptLinksDirective, selectors: [["", "interceptLinks", ""], ["", "intercept-links", ""]], hostBindings: function InterceptLinksDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function InterceptLinksDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { dialogId: "dialogId", exclude: "exclude" }, exportAs: ["interceptLinks"] });
/** @nocollapse */
InterceptLinksDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Router },
    { type: ViewportScroller }
];
InterceptLinksDirective.propDecorators = {
    dialogId: [{ type: Input }],
    exclude: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InterceptLinksDirective, [{
        type: Directive,
        args: [{
                selector: '[interceptLinks], [intercept-links]',
                exportAs: 'interceptLinks'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.Router }, { type: ɵngcc2.ViewportScroller }]; }, { dialogId: [{
            type: Input
        }], exclude: [{
            type: Input
        }], 
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Disables rendering of DOM element on the server.
 *
 * Usage:
 *
 *  <div *noSSR>
 *      This content will not be rendered by the server!
 *  </div>
 */
class NoSSRDirective {
    /**
     * @param {?} templateRef
     * @param {?} viewContainer
     * @param {?} platformId
     */
    constructor(templateRef, viewContainer, platformId) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.platformId = platformId;
        if (isPlatformServer(this.platformId)) {
            this.viewContainer.clear();
        }
        else {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
/** @nocollapse */
NoSSRDirective.ɵfac = function NoSSRDirective_Factory(t) { return new (t || NoSSRDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
/** @nocollapse */
NoSSRDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NoSSRDirective, selectors: [["", "noSSR", ""], ["", "no-ssr", ""]] });
/** @nocollapse */
NoSSRDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NoSSRDirective, [{
        type: Directive,
        args: [{
                selector: '[noSSR], [no-ssr]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DynamicRoutingModule {
}
/** @nocollapse */
DynamicRoutingModule.ɵfac = function DynamicRoutingModule_Factory(t) { return new (t || DynamicRoutingModule)(); };
/** @nocollapse */
DynamicRoutingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DynamicRoutingModule });
/** @nocollapse */
DynamicRoutingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicRoutingModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DynamicComponentComponent,
                    InterceptLinksDirective,
                    NoSSRDirective,
                ],
                exports: [
                    DynamicComponentComponent,
                    InterceptLinksDirective,
                    NoSSRDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DynamicRoutingModule, { declarations: [DynamicComponentComponent, InterceptLinksDirective, NoSSRDirective], exports: [DynamicComponentComponent, InterceptLinksDirective, NoSSRDirective] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DefaultRouteReuseStrategy {
    /**
     * @param {?} route
     * @return {?}
     */
    shouldDetach(route) {
        return false;
    }
    /**
     * @param {?} route
     * @param {?} handle
     * @return {?}
     */
    store(route, handle) { }
    /**
     * @param {?} route
     * @return {?}
     */
    shouldAttach(route) {
        return false;
    }
    // tslint:disable-next-line:no-null-keyword
    /**
     * @param {?} route
     * @return {?}
     */
    retrieve(route) {
        return null;
    }
    /**
     * @param {?} future
     * @param {?} curr
     * @return {?}
     */
    shouldReuseRoute(future, curr) {
        return future.routeConfig === curr.routeConfig;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NoReuseStrategy extends DefaultRouteReuseStrategy {
    /**
     * @param {?} future
     * @param {?} curr
     * @return {?}
     */
    shouldReuseRoute(future, curr) {
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OptionalReuseStrategy extends DefaultRouteReuseStrategy {
    /**
     * @param {?} future
     * @param {?} curr
     * @return {?}
     */
    shouldReuseRoute(future, curr) {
        /** @type {?} */
        const reuse = future.data && future.data.hasOwnProperty('reuse')
            ? future.data.reuse
            : true;
        return super.shouldReuseRoute(future, curr) && reuse;
    }
}
/** @nocollapse */
OptionalReuseStrategy.ɵfac = /*@__PURE__*/ function () { let ɵOptionalReuseStrategy_BaseFactory; return function OptionalReuseStrategy_Factory(t) { return (ɵOptionalReuseStrategy_BaseFactory || (ɵOptionalReuseStrategy_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(OptionalReuseStrategy)))(t || OptionalReuseStrategy); }; }();
/** @nocollapse */
OptionalReuseStrategy.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: OptionalReuseStrategy, factory: OptionalReuseStrategy.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OptionalReuseStrategy, [{
        type: Injectable
    }], null, null); })();

export { DynamicRoutingModule, NoReuseStrategy, OptionalReuseStrategy, DynamicComponentComponent as ɵa, InterceptLinksDirective as ɵb, NoSSRDirective as ɵc, DefaultRouteReuseStrategy as ɵd };

